import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "auto",
    backgroundColor: tokens.colorNeutralBackground1,
  },
  header: {
    width: "100%",
    flexDirection: "row",
    alignItems: "flex-start",
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorPaletteMinkForeground2,
    ...shorthands.padding("16px"),
    "@media (min-width: 500px)": {
      backgroundColor: tokens.colorNeutralBackground1,
    },
  },
  main: {
    display: "flex",
    flexDirection: "column",
    ...shorthands.gap("1px"),
  },
  option: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    ...shorthands.padding("10px", "13px", "10px", "16px"),
  },
});
